module.exports = __webpack_public_path__ + "static/img/Canoe-Default.db0d21e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Canoe-Default.png
// module id = 1584
// module chunks = 0